import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import AnimalTable from './AnimalTable';
import FormDivider from '../components/FormDivider';
import { USDAList, USDAAnimalList, USDAExceptionList } from './utils';

export const isUSDAAnimal = (animal) => {
  animal = animal.toLowerCase();

  const animalObject = USDAList[animal];

  if (animalObject !== undefined) {
    return animalObject.USDA === 'x' ? { found: true, isUSDA: true } : { found: true, isUSDA: false };
  }

  if (USDAAnimalList.includes(animal)) return { found: true, isUSDA: true };
  if (USDAExceptionList.includes(animal)) return { found: true, isUSDA: false };

  return { found: false, isUSDA: true };
};

const TableSwitch = ({ species, sendInput, children, allRequired, val, USDAStatus, setUSDAStatus }) => {
  useEffect(() => {
    setUSDAStatus(isUSDAAnimal(species));
  }, [species]);
  if (USDAStatus.isUSDA) {
    return (
      <>
        <Grid item xs={12} textAlign="left">
          <FormDivider text="Animals" />
        </Grid>
        <Grid item xs={12} textAlign="left">
          <AnimalTable sendInput={sendInput} val={val} allRequired={allRequired} />
        </Grid>
      </>
    );
  }

  return <>{children}</>;
};

export default TableSwitch;
